import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'

export function useWindcaveQuery() {
    const rpQuery = useRpQuery()

    async function queryWindcaveSession(
        paymentSourceId: string,
        amount?: string
    ) {
        if (amount !== undefined) {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    query WindcavePurchaseFormQuery(
                        $paymentSourceId: ID!
                        $input: WindcavePurchaseSessionInput!
                    ) {
                        node(id: $paymentSourceId) {
                            __typename
                            ... on PaymentSource {
                                data {
                                    __typename
                                    ... on PaymentSourceCreditCardWindcave {
                                        purchaseSession(input: $input) {
                                            url
                                            supportedCards
                                            sessionId
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    paymentSourceId,
                    input: {
                        amount
                    }
                }
            )

            if (
                response.node === null ||
                response.node.__typename !== 'PaymentSource' ||
                response.node.data === null ||
                response.node.data.__typename !==
                    'PaymentSourceCreditCardWindcave'
            ) {
                throw new Error()
            }

            // Save session data
            return response.node.data.purchaseSession
        } else {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    query WindcaveSetupFormQuery($paymentSourceId: ID!) {
                        node(id: $paymentSourceId) {
                            __typename
                            ... on PaymentSource {
                                data {
                                    __typename
                                    ... on PaymentSourceCreditCardWindcave {
                                        tokenizeSession {
                                            url
                                            supportedCards
                                            sessionId
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    paymentSourceId
                }
            )

            if (
                response.node === null ||
                response.node.__typename !== 'PaymentSource' ||
                response.node.data === null ||
                response.node.data.__typename !==
                    'PaymentSourceCreditCardWindcave'
            ) {
                throw new Error()
            }

            // Save session data
            return response.node.data.tokenizeSession
        }
    }

    return {
        queryWindcaveSession
    }
}
